﻿(() => {
    const bbbioForm = document.getElementById("bbbio-microbiome-form");
    const bbbioSamplesContainer = document.getElementById("bbbio-samples");
    const bbbioTemplate = document.getElementById("bbbio-sample-template");
    const bbbioStatus = document.getElementById("bbbio-status");
    const bbbioAuthorizationDate = document.getElementById("bbbio-authorization-date");
    const bbbioContactName = document.querySelector("[data-bbbio-microbiome-contact-name]");
    const bbbioContactEmail = document.querySelector("[data-bbbio-microbiome-contact-email]");
    const bbbioContactPhone = document.querySelector("[data-bbbio-microbiome-contact-phone]");
    const bbbioContactBody = document.querySelector("[data-bbbio-microbiome-contact-body]");

    if (!bbbioForm || !bbbioSamplesContainer || !bbbioTemplate || !bbbioStatus || !bbbioContactName || !bbbioContactEmail || !bbbioContactPhone || !bbbioContactBody) return;

    const bbbioServiceNames = {
      extraction: "Microbial DNA extraction",
      "16s": "16S rRNA gene sequencing",
      its: "ITS fungal profiling",
      "custom-amplicon": "Custom microbial amplicon sequencing",
      shotgun: "Shotgun metagenomic sequencing",
      "isolate-wgs": "Bacterial isolate whole-genome sequencing"
    };

    function bbbioShowStatus(message, type = "success") {
      bbbioStatus.textContent = message;
      bbbioStatus.dataset.bbbioVisible = "true";
      bbbioStatus.dataset.bbbioType = type;
    }

    function bbbioClearStatus() {
      bbbioStatus.textContent = "";
      bbbioStatus.dataset.bbbioVisible = "false";
      delete bbbioStatus.dataset.bbbioType;
    }

    function bbbioSetConditional(group, visible) {
      group.hidden = !visible;
      group.querySelectorAll("input, select, textarea").forEach((control) => {
        control.disabled = !visible;
      });
    }

    function bbbioAssignDynamicLabels(card, sampleNumber) {
      card.querySelectorAll("[data-bbbio-field]").forEach((control) => {
        const fieldKey = control.dataset.bbbioField;
        const slug = fieldKey.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        const controlId = `bbbio-sample-${sampleNumber}-${slug}`;
        control.id = controlId;
        control.name = `sample_${sampleNumber}_${fieldKey}`;

        const wrapper = control.closest(".bbbio-form-field");
        if (wrapper) {
          const label = wrapper.querySelector("label:not(.bbbio-choice)");
          if (label) label.htmlFor = controlId;
        }
      });

      card.querySelectorAll("[data-bbbio-service]").forEach((control) => {
        const key = control.dataset.bbbioService;
        control.id = `bbbio-sample-${sampleNumber}-service-${key}`;
        control.name = `sample_${sampleNumber}_services`;
        control.value = key;
      });
    }

    function bbbioRenumberSamples() {
      const cards = Array.from(bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card"));
      cards.forEach((card, index) => {
        const sampleNumber = index + 1;
        card.dataset.bbbioSampleIndex = String(sampleNumber);

        const number = card.querySelector(".bbbio-sample-number");
        if (number) number.textContent = String(sampleNumber);

        bbbioAssignDynamicLabels(card, sampleNumber);
      });

      cards.forEach((card) => {
        const removeButton = card.querySelector(".bbbio-remove-sample");
        if (removeButton) removeButton.disabled = cards.length === 1;
      });
    }

    function bbbioUpdateSampleWarning(card) {
      const material = card.querySelector(".bbbio-sample-material").value;
      const shotgun = card.querySelector("[data-bbbio-service='shotgun']").checked;
      const isolateWgs = card.querySelector("[data-bbbio-service='isolate-wgs']").checked;
      const warning = card.querySelector(".bbbio-sample-warning");

      let message = "";
      if (shotgun && material === "Amplicon or PCR product") {
        message = "Shotgun metagenomics requires total community DNA or source material, not an amplicon or PCR product.";
      } else if (
        isolateWgs &&
        material &&
        material !== "Bacterial isolate culture or pellet" &&
        material !== "Purified microbial or metagenomic DNA"
      ) {
        message = "Bacterial isolate WGS normally requires a pure bacterial isolate or purified isolate DNA. Confirm the material or requested service.";
      }

      warning.textContent = message;
      warning.dataset.bbbioVisible = message ? "true" : "false";
    }

    function bbbioUpdateMaterialFields(card) {
      const material = card.querySelector(".bbbio-sample-material").value;
      const ampliconSelected = ["16s", "its", "custom-amplicon"].some((service) => {
        return card.querySelector(`[data-bbbio-service="${service}"]`).checked;
      });
      const isolateSelected = card.querySelector("[data-bbbio-service='isolate-wgs']").checked;

      const conditions = [
        [".bbbio-amplicon-fields", ampliconSelected],
        [".bbbio-environment-fields", [
          "Soil or sediment",
          "Water sample or filter",
          "Food or feed sample",
          "Plant-associated sample"
        ].includes(material)],
        [".bbbio-host-associated-fields", [
          "Oral or saliva sample",
          "Swab",
          "Tissue or biopsy",
          "Blood, plasma, or other low-biomass fluid"
        ].includes(material)],
        [".bbbio-isolate-fields", isolateSelected || [
          "Bacterial isolate culture or pellet",
          "Fungal isolate culture or material"
        ].includes(material)]
      ];

      conditions.forEach(([selector, visible]) => {
        const group = card.querySelector(selector);
        if (group) bbbioSetConditional(group, visible);
      });

      bbbioUpdateSampleWarning(card);
    }

    function bbbioAddSample(shouldFocus = true) {
      const fragment = bbbioTemplate.content.cloneNode(true);
      const card = fragment.querySelector(".bbbio-sample-card");

      card.querySelector(".bbbio-remove-sample").addEventListener("click", () => {
        if (bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card").length > 1) {
          card.remove();
          bbbioRenumberSamples();
        }
      });

      card.querySelector(".bbbio-sample-material").addEventListener("change", () => {
        bbbioUpdateMaterialFields(card);
      });

      card.querySelectorAll("[data-bbbio-service]").forEach((box) => {
        box.addEventListener("change", () => bbbioUpdateMaterialFields(card));
      });

      bbbioSamplesContainer.appendChild(fragment);
      bbbioRenumberSamples();
      bbbioUpdateMaterialFields(card);

      if (shouldFocus) {
        const firstField = card.querySelector("[data-bbbio-field='sampleId']");
        if (firstField) firstField.focus();
      }
    }

    function bbbioAddValue(target, key, value) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = Array.isArray(target[key]) ? target[key].concat(value) : [target[key], value];
      } else {
        target[key] = value;
      }
    }

    function bbbioCollectData() {
      const data = {};
      const samples = [];

      new FormData(bbbioForm).forEach((value, key) => {
        const isSystemField = key.startsWith("contact[")
          || ["form_type", "utf8", "h-captcha-response", "g-recaptcha-response"].includes(key);
        if (!key.startsWith("sample_") && !key.startsWith("attest") && !isSystemField) {
          bbbioAddValue(data, key, value);
        }
      });

      bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card").forEach((card) => {
        const sample = {};

        card.querySelectorAll("[data-bbbio-field]:not(:disabled)").forEach((control) => {
          if (control.value !== "") sample[control.dataset.bbbioField] = control.value;
        });

        sample.services = Array.from(card.querySelectorAll("[data-bbbio-service]:checked")).map((control) => {
          return bbbioServiceNames[control.dataset.bbbioService];
        });

        samples.push(sample);
      });

      data.samples = samples;
      data.customerAttestations = {
        accurate: document.getElementById("bbbio-attest-accurate").checked,
        noDirectIdentifiers: document.getElementById("bbbio-attest-identifiers").checked,
        hazardsDisclosed: document.getElementById("bbbio-attest-hazards").checked
      };
      data.generatedAt = new Date().toISOString();

      return data;
    }

    function bbbioValidateSelections() {
      if (!bbbioForm.querySelector("input[name='requestedServices']:checked")) {
        return "Select at least one microbiome or microbial genomics service.";
      }

      const missingSampleService = Array.from(
        bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card")
      ).some((card) => !card.querySelector("[data-bbbio-service]:checked"));

      return missingSampleService
        ? "Select at least one microbiome or microbial genomics service for every sample."
        : "";
    }

    document.getElementById("bbbio-add-sample").addEventListener("click", () => bbbioAddSample(true));
    document.getElementById("bbbio-print-form").addEventListener("click", () => window.print());

    bbbioForm.addEventListener("submit", (event) => {
      bbbioClearStatus();

      if (!bbbioForm.checkValidity()) {
        event.preventDefault();
        bbbioForm.reportValidity();
        bbbioShowStatus("Complete all required fields before submitting the request.", "error");
        return;
      }

      const selectionError = bbbioValidateSelections();
      if (selectionError) {
        event.preventDefault();
        bbbioShowStatus(selectionError, "error");
        return;
      }

      bbbioContactName.value = bbbioForm.elements.contactName.value;
      bbbioContactEmail.value = bbbioForm.elements.email.value;
      bbbioContactPhone.value = bbbioForm.elements.phone.value;
      bbbioContactBody.value = `MICROBIOME AND MICROBIOTA SEQUENCING SERVICE REQUEST\n\n${JSON.stringify(bbbioCollectData(), null, 2)}`;
      bbbioShowStatus("Submitting your request securely…");
    });

    document.getElementById("bbbio-download-json").addEventListener("click", () => {
      bbbioClearStatus();

      if (!bbbioForm.checkValidity()) {
        bbbioForm.reportValidity();
        bbbioShowStatus("Complete all required fields before exporting the request.", "error");
        return;
      }

      const selectionError = bbbioValidateSelections();
      if (selectionError) {
        bbbioShowStatus(selectionError, "error");
        return;
      }

      const blob = new Blob(
        [JSON.stringify(bbbioCollectData(), null, 2)],
        { type: "application/json" }
      );
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "bnb-bio-microbiome-microbiota-sequencing-request.json";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      bbbioShowStatus("Request JSON created locally. No submission was transmitted.");
    });

    bbbioForm.addEventListener("reset", () => {
      setTimeout(() => {
        bbbioSamplesContainer.innerHTML = "";
        bbbioAddSample(false);
        bbbioClearStatus();
        if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
      }, 0);
    });

    if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
    bbbioAddSample(false);
  })();
